
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { routeConfig } from './routeConfig';
import RouteGuard from './RouteGuard';

const AppRoutes = () => {
  return (
    <Routes>
      {routeConfig.map(({ path, element, isPrivate, membershipTypes }, index) => {
        const wrappedElement = isPrivate ? (
          <RouteGuard membershipTypes={membershipTypes}>{element}</RouteGuard>
        ) : (
          element
        );

        return <Route key={index} path={path} element={wrappedElement} />;
      })}
    </Routes>
  );
}

export default AppRoutes;